import {
    qnAdvSlotList
} from "./adv_slots";

console.debug(qnAdvSlotList);

const DIV_ID_PREFIX = "div-gpt-ad-";

window.pcp = window.pcp || [];
console.debug("Pending tasks", pcp);

var pending = window.pcp;

function executeTask(cmd) {
    if (typeof cmd === "function") {
        cmd();
    }
}

function loadGPTScript() {
    var tag = document.createElement("script");
    tag.type = "text/javascript";
    tag.src = 'https://www.googletagservices.com/tag/js/gpt.js';
    var node = document.getElementsByTagName('script')[0];
    node.parentNode.insertBefore(tag, node);
    window.googletag = window.googletag || { cmd: [] };
}

function defineSlot(slot, sizes, divId, outOfPage) {
    console.debug("Add GPT definition for", slot)
    if (outOfPage) {
        googletag.cmd.push(function () {
            googletag
                .defineOutOfPageSlot(
                    slot, divId)
                .addService(googletag.pubads());
            console.debug("GPT defined", slot)
        });

    } else {
        googletag.cmd.push(function () {
            googletag
                .defineSlot(
                    slot, sizes, divId)
                .addService(googletag.pubads());
            console.debug("GPT defined", slot)
        });
    }
}

function enableServices() {
    googletag.cmd.push(function () {
        googletag.pubads().enableLazyLoad();
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().setCentering(true);
        googletag.enableServices();
    });
}

function setPageTargeting() {
    var targetingDict = pcp.MonrifPolopolyUtility.TagManager || {};
    targetingDict.device = pcp.device;
    if (pcp.thirdLevelDomain) targetingDict.site = pcp.thirdLevelDomain;
    googletag.cmd.push(function () {
        for (var k in targetingDict) googletag.pubads().setTargeting(k, targetingDict[k]);
    });
}

function getSlotOptions(slotName) {
    for (var i = 0; i < qnAdvSlotList.length; i++) {
        if (qnAdvSlotList[i].unit === slotName) {
            return qnAdvSlotList[i];
        }
    }
}

function init() {
    window.pcp = {
        define: function (path, positions, device) {
            console.debug(path, positions);
            console.debug("Device", device);
            pcp.device = device;
            if ("globals" in window) {
                pcp.thirdLevelDomain = window.globals.customDomain;
            }
            pcp.MonrifPolopolyUtility = window.MonrifPolopolyUtility || {};
            console.debug("Load GPT");
            loadGPTScript();
            pcp.__defined = [];
            for (var i = 0; i < positions.length; i++) {
                var slotName = positions[i];
                var slotOptions = getSlotOptions(slotName);
                if (slotOptions !== null) {
                    if (slotOptions.device !== pcp.device) {
                        continue;
                    }
                    var adUnitPath = path;
                    if ("custom_adunit_dir" in slotOptions && slotOptions.custom_adunit_dir != "") {
                        var speedConf = (pcp.MonrifPolopolyUtility.aggregatorValues || {}).speed || {};
                        adUnitPath = speedConf.code || "";
                        adUnitPath += slotOptions.custom_adunit_dir.replace(/\{[^}]+\}/gi, function (m) {
                            var k = m.substring(1, m.length - 1).toLowerCase();
                            if (k in speedConf) return speedConf[k];
                            return "";
                        });
                        if (!adUnitPath.match(/\/$/)) adUnitPath += "/";
                    }
                    adUnitPath += positions[i];
                    defineSlot(adUnitPath,
                        slotOptions.sizes,
                        DIV_ID_PREFIX + slotName,
                        slotOptions.outOfPage);
                    pcp.__defined.push(DIV_ID_PREFIX + slotName);
                } else {
                    console.warn(slotName, "not defined");
                }
            }
            setPageTargeting();
            enableServices();
        },
        push: function (cmd) {
            executeTask(cmd);
        },
        display: function (divId) {
            if (pcp.__defined.indexOf(divId) === -1) {
                console.debug(divId, "not defined");
                return
            }
            googletag.cmd.push(function () {
                googletag.display(divId);
            });
        }
    }
    for (var i = 0; i < pending.length; i++) {
        executeTask(pending[i])
    }
}

window.requireConsent = window.requireConsent || [];
requireConsent.push(function () {
    init();
});